import { WORK_KINDS, type WorkKind } from '@glory/sales/domain';

const text = (value: unknown): string | undefined =>
  typeof value === 'string' && value !== '' ? value : undefined;

const flag = (value: unknown): true | undefined => (value === true || value === 'true' ? true : undefined);

/** «Лиды» живут в адресе: фильтр, состояние и открытая карточка — ссылкой можно поделиться. */
export interface LeadsSearch {
  /** Открытая в панели карточка. */
  readonly deal?: string | undefined;
  /** Без значения — «Все». */
  readonly filter?: 'queue' | 'mine' | undefined;
  /** Без значения — открытые; отложенные и отклонённые — отдельно. */
  readonly state?: 'postponed' | 'rejected' | undefined;
  /** Поставить курсор в строку быстрого ввода — команда ⌘K «Новый лид». */
  readonly create?: true | undefined;
  /** Открыть «Быстрый расчёт» без лида — кнопка на «Лидах» и команда ⌘K. */
  readonly quick?: true | undefined;
}

export function parseLeadsSearch(search: Record<string, unknown>): LeadsSearch {
  return {
    deal: text(search.deal),
    filter: search.filter === 'queue' || search.filter === 'mine' ? search.filter : undefined,
    state: search.state === 'postponed' || search.state === 'rejected' ? search.state : undefined,
    create: flag(search.create),
    quick: flag(search.quick),
  };
}

/** «Воронка»: доска или таблица, «Мои / Все / ответственный / вид работы», закрытые — фильтром. */
export interface PipelineSearch {
  readonly deal?: string | undefined;
  /** Без значения — доска. */
  readonly view?: 'table' | undefined;
  /**
   * «Мои» — где вы ответственный; «Без ответственного» — сделки отключённых сотрудников (у `sales.read_all`);
   * без значения — «Все».
   */
  readonly scope?: 'mine' | 'unassigned' | undefined;
  readonly responsible?: string | undefined;
  readonly work?: WorkKind | undefined;
  /** Показать выигранные и проигранные. */
  readonly closed?: true | undefined;
}

export function parsePipelineSearch(search: Record<string, unknown>): PipelineSearch {
  return {
    deal: text(search.deal),
    view: search.view === 'table' ? 'table' : undefined,
    scope: search.scope === 'mine' || search.scope === 'unassigned' ? search.scope : undefined,
    responsible: text(search.responsible),
    work: WORK_KINDS.find((kind) => kind === search.work),
    closed: flag(search.closed),
  };
}
